import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import BackArrow from 'src/atoms/backArrow/backArrow'
import FloatingInput from 'src/atoms/floatingInput/floatingInput'
import { makeAPICall } from 'src/services/apiService'
import "./CodeOfflinePayment.css"
import PageLoader from 'src/atoms/pageLoader'
import { deleteCookie, getCookie, setCookie } from '../../../src/utils/utils'

function CodeOfflinePayment() {
    const history = useHistory()
    const [codeValue, setCodeValue] = useState("")
    const [response, setResponse] = useState("")
    console.log('response:', response)
    const [showError, setShowError] = useState(false)
    const [btnDisable, setBtnDisable] = useState(true)
    const [loading, setLoading] = useState(getCookie('from_purchase_flow') == 'true' ? true : false);
    const [splitPayments, setSplitPayments] = useState([])
    const [userInfo, setUserInfo] = useState({});

    useEffect(() => {
        if (getCookie('from_purchase_flow') == 'true') {
            let obj = {
                "order_id": getCookie('buyer_orderId'),
                "name": getCookie('buyer_name'),
                "phone": getCookie('user_phone_number'),
                "customer_id": getCookie('buyer_utm_uuid')
            }
            setUserInfo(obj)
            sessionStorage.setItem('user_details', JSON.stringify(obj))
            setCodeValue(getCookie('unique_code') || '')
        } else {
            setUserInfo(JSON.parse(sessionStorage.getItem("user_details")))
        }
    }, [])


    useEffect(() => {
        if (codeValue.length === 0) {
            console.log("keep border green ");
        }
        else if (codeValue.length > 0 && codeValue.length < 5) {
            console.log("keep border green ");
            setShowError(false)
        }
        else if (codeValue.length === 6) {
            checkUniqueCode()
            console.log("make api call");
            console.log("based on api response change the css");
        }

    }, [codeValue])

    const getOfflineSplits = async () => {
        let offlineSplitsPayload = {
            method: 'get',
            url: 'api/offlinePayment/getOfflineSplits',
            params: {
                orderId: userInfo?.order_id,
                customer_uuid: userInfo?.customer_id
            }
        }
        await makeAPICall(offlineSplitsPayload)
            .then((resp) => {
                setSplitPayments(resp.data?.all_payment_transactions?.filter(item => item.payment_type == "SPLIT_PAYMENT") || [])
            })
            .catch((err) => {
                console.log("error in getting offlineSplits Payload", err);
            })
    }

    function checkUniqueCode() {
        setLoading(true)
        let putUniqueCode = {
            method: "PUT",
            url: "/api/offlinePayment/checkUniqueCode",
            params: {
                unique_code: codeValue,
                user_code: userInfo?.order_id
            }
        }
        makeAPICall(putUniqueCode)
            .then(async (response) => {
                await getOfflineSplits()
                setCookie("offline_unique_code", codeValue);
                setBtnDisable(false)
                console.log(response, "unique code successfull ");
                setShowError(false)
                if (getCookie('from_purchase_flow') == 'true')
                    handleContinue();
                else
                    setLoading(false)
            })
            .catch((err) => {
                deleteCookie(["offline_unique_code"])
                setBtnDisable(true)
                setShowError(true)
                setResponse("invalid unique code")
                console.log("Error in unique code", err);
                setLoading(false)
            })
        // }
    }

    function handleContinue() {
        console.log("splitPayments", splitPayments)
        if(localStorage.getItem("ola_care_ew_payment_initiated") == "true"){
            history.push(`/offlinePayment?olaCareEwPayment=true`)    
        }else{
            history.push(`/offlinePayment?${splitPayments.length > 0 ? 'isSplitPayment=true' : ''}`)
        }
    }

    if(loading)
        return <PageLoader />

    return (  <div className='code-op-wrapper'>
            <div onClick={() => history.goBack()}>
                <BackArrow removeClass={true} />
            </div>
            <div className="code-op-title">
                Enter unique code of the customer
            </div>
            <div className='code-op-name-phone-section'>
                <div className="code-op-name">{userInfo?.name}</div>
                <div className="code-op-phone">{userInfo?.phone}</div>
            </div>
            <div className="code-op-div">
                <FloatingInput
                    //   disabled={true}
                    extraCss={"whiteBg"}
                    id="Unique Code"
                    name="Unique Code"
                    maxLength={6}
                    type="text"
                    labelName="Unique Code"
                    inputValue={codeValue}
                    onChange={(e) => { setCodeValue(e?.target?.value) }}
                    // className={`card-number ${idInputClass}`}
                    placeholder="Unique Code"
                    labelStyles={{ color: showError ? "#D44C59" : "" }}
                />
            </div>
            {showError && <div className='code-op-error'>{response}</div>}
            <div className="code-continue-btn">

            </div>

            <div className='code-op-btn-div'>
                <button onClick={() => { handleContinue() }} disabled={btnDisable} className={`code-op-bt ${btnDisable ? "code-op-disable-btn" : ""}`}>Continue</button>
            </div>
        </div>
    )
}

export default CodeOfflinePayment